export default __webpack_public_path__ + "static/media/IconDesc_SnowballProjectile.256.c7442082.png";